import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import { maxWidth } from '../../helpers/media-queries';


const styles = ({ palette, sizes }) => ({
    root: {
        position: 'relative',
        '& .container': {
            padding: `0 ${sizes.baseSize * 3}px ${sizes.baseSize}px`,
            maxWidth: '1080px',
            backgroundColor: palette.fliperama.main,
            borderLeft: '8px solid #001c28',
            borderRight: '8px solid #001c28',
            [maxWidth.lg]: {
                padding: `0 ${sizes.baseSize}px ${sizes.baseSize * 2}px`,
                borderWidth: '5.5px'
            },
            [maxWidth.sm]: {
                padding: `0 0 ${sizes.baseSize}px`,
                borderWidth: '2px',
            },
        },
    }
});

class DecoratedSection extends React.Component {
    ref = React.createRef();
    render(){
        const { onReveal: onEnter, onLeave, classes, children, className, ...props } = this.props;
        return (
            <section {...props} className={classNames(classes.root, className)}>
                <div className={"container"}>
                    {children}
                </div>
            </section>
        )
    }
}

export const Section = withStyles(styles)(DecoratedSection);